import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import ReviewPage from "./ReviewPage";

function SonographyServices() {
  return (
    <>
      <div id="sonography-services"></div>
      <Header />
      <section className=" page p-0 m-0 gap-0">
        <div>
          {/* Header */}
          <div className="bg-light py-0 text-center">
            <h1
              className="contact-bg pt-0 text-light  text-uppercase  text-center  fw-bold col-md-12 col-lg-12 col-sm-12 "
              style={{
                fontSize: "3rem",
                letterSpacing: "3.5px",
                borderBottom: "7px solid gold",
                borderRadius: "5px",
                display: "inline-block",
                paddingBottom: "5px",
              }}
            >
              Sonography
            </h1>
          </div>

          {/* Main Section / part 1*/}
          <div className="container my-5">
            <div className="row align-items-center g-4">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Get Sonography Services at Rapid Lab Diagnostics
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>

                <p className="text-primary-emphasis">
                  Rapid Lab Diagnostics is committed to delivering high-quality
                  sonography services using state-of-the-art equipment and
                  highly skilled, experienced technicians. Our advanced imaging
                  technology ensures clear, precise, and detailed results,
                  enabling healthcare providers to accurately diagnose and
                  monitor a wide range of medical conditions with confidence. We
                  offer comprehensive ultrasound services tailored to meet
                  diverse patient needs, from routine diagnostic scans to
                  specialized imaging and pregnancy monitoring. Every procedure
                  is carried out with a strong focus on accuracy, safety, and
                  patient comfort. Our team takes the time to guide patients
                  through each step of the process, ensuring they feel informed,
                  supported, and at ease during their visit. At Rapid Lab
                  Diagnostics, we understand that medical imaging can be a
                  sensitive and sometimes stressful experience. That’s why we
                  prioritize compassionate, patient-centered care in a welcoming
                  and professional environment. We strive to minimize wait times
                  while maintaining the highest standards of quality and
                  attention to detail. Whether you are visiting for an initial
                  diagnosis, follow-up imaging, or prenatal care, you can trust
                  our team to provide reliable results and exceptional service.
                  Contact us today to schedule your sonography appointment and
                  discover the difference that expertise, advanced technology,
                  and genuine care can make in your healthcare experience.
                </p>

                <p className="text-primary-emphasis">
                  {" "}
                  if you have any questions or concerns about the HSG procedure,
                  our team is here to assist you every step of the way.
                </p>
              </div>
              {/* Right Images */}
              <div className="col-lg-6 text-center pt-3">
                <img
                  src="images/assets/doctor-sonography.png"
                  alt="sonography"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "400px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                />

                {/* Thumbnails */}
                <div className="d-flex justify-content-center gap-2">
                  <img
                    src="https://rgshealthcare.com/wp-content/uploads/2024/05/1200px_rgsHealthCare_AdobeStock_405836547-768x512.jpg"
                    alt="lab1"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="images/assets/x-ray.png"
                    alt="x-ray"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="images/assets/ultraSound.jpeg"
                    alt="lab3"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
            {/* put  CARD HERE */}
            <div
              className="card mb-3 mt-3 pt-md-2 shadow-sm rounded"
              style={{ maxWidth: "600px", borderTop: "4px solid #FFD700" }}
            >
              <div className="row g-0">
                <div className="col-md-12">
                  <div className="card-body">
                    <h5 className="card-title text-primary-emphasis fw-semibold">
                      How it Works
                    </h5>
                    <p className="card-text col-12">
                      A device called a transducer is placed on the skin over
                      the area being examined. Before this, a special gel is
                      applied to help the sound waves travel efficiently through
                      the body. The transducer emits high-frequency sound waves
                      that are not audible to humans. These waves travel into
                      the body and bounce off internal structures such as
                      organs, tissues, or fluids. As the sound waves reflect
                      back, the transducer picks up the echoes and sends them to
                      a computer. The computer then processes these signals and
                      converts them into real-time images displayed on a
                      monitor. Different tissues reflect sound waves
                      differently, which is how the system distinguishes between
                      various structures and creates detailed images.
                    </p>
                    <p className="card-text col-12"></p>
                  </div>
                </div>
              </div>
            </div>
            {/* Banner */}
            <div className="container my-5">
              <div
                className="d-flex flex-column flex-md-row align-items-center justify-content-between p-5"
                style={{
                  backgroundColor: "#0f5b7f",
                  borderRadius: "12px",
                }}
              >
                {/* Left Text */}
                <h2
                  className="text-white mb-4 mb-md-0"
                  style={{
                    fontSize: "32px",
                    fontWeight: "500",
                    maxWidth: "700px",
                    lineHeight: "1.4",
                  }}
                >
                  Visit Us for Your Laboratory Needs and Experience the
                  Difference in Care and Quality
                </h2>

                {/* Right Button */}
                <Link
                  className="link-underline link-underline-opacity-0 text-decoration-none"
                  to="https://www.google.com/maps/place/Rapid+Lab+and+Diagnostics+center/@5.6747617,-0.0208036,21z/data=!4m6!3m5!1s0xfdf813ca0f57087:0xef5fd0638781ba41!8m2!3d5.6748397!4d-0.0208213!16s%2Fg%2F11t6hmrfy0?entry=ttu&g_ep=EgoyMDI2MDMyMi4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                >
                  <button
                    className="btn text-white d-flex align-items-center gap-2"
                    style={{
                      border: "2px solid white",
                      padding: "12px 24px",
                      borderRadius: "6px",
                      fontWeight: "500",
                    }}
                  >
                    LOCATION
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-caret-right-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                      </svg>
                    </span>
                  </button>
                </Link>
              </div>
            </div>
            {/* part 2 */}
            <div className="row align-items-center g-4 py-5 mt-5">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Reasons for Sonography Services at Rapid Lab Diagnostics
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>
                <p className="text-primary-emphasis">
                  Sonography is commonly used to evaluate the shape and
                  structure of the uterus and surrounding reproductive organs.
                  It helps identify abnormalities, such as fibroids or cysts,
                  and can provide important insights into conditions that may be
                  affecting fertility or overall reproductive health.
                </p>
                <p className="text-primary-emphasis">
                  <ul className="p-0 m-0 ">
                    <li className="list-unstyled  pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}Sonography helps detect causes of infertility and
                        guides effective treatment decisions.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        It can monitor pregnancy health and fetal development,
                        providing valuable information for expectant mothers and
                        their healthcare providers.
                      </span>
                    </li>
                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Sonography can also be used to evaluate the uterus and
                        fallopian tubes after certain medical procedures or
                        surgeries to ensure proper healing and function.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        It is a non-invasive, safe, and effective diagnostic
                        tool that provides valuable insights into various
                        medical conditions, helping guide appropriate treatment
                        and care.
                      </span>
                    </li>
                  </ul>
                </p>

                <p className="text-primary-emphasis">
                  If you are seeking sonography services, Rapid Lab Diagnostics
                  is here to provide you with expert care, advanced technology,
                  and a compassionate approach to meet your healthcare needs.
                  Contact us today to schedule your appointment and experience
                  the difference in quality and care that we offer.
                </p>
              </div>

              {/* Right Images */}
              <div className="col-lg-6 text-center">
                <img
                  src="images/assets/kike-vega-F2qh3yjz6Jk-unsplash.jpg"
                  alt="exercise"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "500px",
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
            {/* Reviews */}

            <div className="container text-center py-5 bg-muted    ">
              <ReviewPage />
              <div className="row align-items-center g-4 py-5 mt-5">
                <div className="col-lg-6 text-center">
                  <img
                    src="images/assets/accuray-6pQPFuD7nJY-unsplash.jpg"
                    alt="rapidLabEnterance"
                    loading="lazy"
                    className="img-fluid rounded mb-3"
                    style={{
                      maxHeight: "500px",
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                <div className="col-lg-6">
                  <h2 className="fw-bold text-primary-emphasis text-start ">
                    Choose Rapid Lab Diagnostics for Your Sonography Services
                    and Experience the Difference in Care and Quality
                  </h2>

                  <div
                    className="my-3 "
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>

                  <p className="text-primary-emphasis text-start">
                    At Rapid Lab Diagnostics, we are dedicated to providing
                    exceptional sonography services that combine advanced
                    technology, expert care, and a compassionate approach. Our
                    state-of-the-art equipment and highly skilled technicians
                    ensure that you receive accurate, detailed, and reliable
                    imaging results. We understand that medical imaging can be a
                    sensitive experience, which is why we prioritize patient
                    comfort and support throughout the entire process. Whether
                    you are seeking diagnostic imaging for reproductive health,
                    pregnancy monitoring, or other medical concerns, our team is
                    here to provide you with the highest level of care and
                    service. Contact us today to schedule your sonography
                    appointment and discover the difference that quality,
                    expertise, and genuine care can make in your healthcare
                    experience.
                  </p>
                </div>
              </div>

              {/* F&Q */}
              <div>
                <p className="fs-3 text-primary-emphasis">
                  Sonography Frequently Asked Questions
                  <div
                    className="my-1 m-auto"
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>
                </p>
              </div>
              {/* Accordion */}
              <div
                className="accordion  col-10  m-auto my-5"
                id="accordionFlushExample "
                style={{ borderTop: "4px solid #FFD700", borderRadius: "8px" }}
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                      style={{ borderRadius: "8px" }}
                    >
                      What happens during an Sonography?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body text-start">
                      During a sonography procedure, a trained technician will
                      apply a special gel to the area of the body being
                      examined. This gel helps the sound waves travel more
                      effectively. The technician will then use a device called
                      a transducer, which emits high-frequency sound waves that
                      are inaudible to humans. The transducer is moved over the
                      skin, and as the sound waves bounce off internal
                      structures, they create echoes. These echoes are captured
                      by the transducer and sent to a computer, which processes
                      the signals and converts them into real-time images
                      displayed on a monitor. The technician may take multiple
                      images from different angles to provide a comprehensive
                      view of the area being examined. The procedure is
                      non-invasive, painless, and typically takes about 30
                      minutes to an hour, depending on the type of sonography
                      being performed.
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                      style={{ borderRadius: "8px" }}
                    >
                      How should I prepare for a Sonography?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body text-start">
                      Preparation for a sonography can vary depending on the
                      type of ultrasound being performed and the area of the
                      body being examined. For abdominal ultrasounds, you may be
                      asked to fast for several hours before the procedure to
                      reduce gas in the intestines, which can interfere with
                      image quality. For pelvic ultrasounds, you may be
                      instructed to drink several glasses of water and avoid
                      urinating before the exam to ensure a full bladder, which
                      helps provide clearer images of the pelvic organs. For
                      other types of ultrasounds, such as those for blood
                      vessels or soft tissues, there may be no special
                      preparation needed. It’s important to follow any specific
                      instructions provided by your healthcare provider or the
                      imaging center to ensure the best possible results from
                      your sonography. If you have any questions about how to
                      prepare for your ultrasound, don’t hesitate to contact our
                      team at Rapid Lab Diagnostics for guidance and support.
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                      style={{ borderRadius: "8px" }}
                    >
                      Is a Sonography safe?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body text-start">
                      Yes, sonography is considered a safe and non-invasive
                      imaging technique. It uses high-frequency sound waves to
                      create images of the body’s internal structures, and it
                      does not involve ionizing radiation like X-rays or CT
                      scans. This makes it a preferred choice for many
                      diagnostic purposes, including monitoring pregnancy and
                      evaluating soft tissues. The procedure is generally
                      painless, and there are no known risks associated with the
                      sound waves used in sonography. However, it’s important to
                      have the procedure performed by a trained and experienced
                      technician to ensure accurate results and minimize any
                      potential discomfort. If you have any concerns about the
                      safety of sonography, our team at Rapid Lab Diagnostics is
                      here to provide you with information and support to help
                      you feel confident in your healthcare decisions.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default SonographyServices;
